module.exports = __webpack_public_path__ + "files/86074f2873499108fb10cdabafffb1c1.png";